import React from 'react';
import {
  BranchIcon,
  BudgetIcon,
  CompanyIcon, EStateFieldIcon, InstructionIcon,
  KDBIcon, KindPaymentsIcon,
  Regions, ContractIcon,
} from '../Styled/Buttons/icons';
import meta from '../../const/meta';
import SubPage from '../MaterialUI/subpage';

const items = [
  {
    url: meta.cat.orgs.frontend,
    title: 'Установи',
    icon: CompanyIcon,
    section: 'org',
    desc: 'Довідник установ',
  },
  {
    url: meta.cat.budgets.frontend,
    title: 'Бюджети',
    icon: BudgetIcon,
    section: 'budget',
    desc: 'Довідник бюджетів',
  },
  {
    url: meta.cat.industries.frontend,
    title: 'Галузі',
    icon: BranchIcon,
    section: 'industry',
    desc: 'Довідник галузей',
  },
  {
    url: meta.cat.kdbs.frontend,
    title: 'КДБ',
    icon: KDBIcon,
    section: 'kdb',
    desc: 'Довідник кодів доходів бюджету',
  },
  {
    url: meta.cat.paymentskins.frontend,
    title: 'Види платежів',
    icon: KindPaymentsIcon,
    section: 'paymentskin',
    desc: 'Довідник видів платежів',
  },
  {
    url: meta.cat.attributes.frontend,
    title: 'Довідник додаткових властивостей',
    icon: InstructionIcon,
    section: 'attribute',
    desc: 'Довідник додаткових властивостей',
  },
  {
    url: meta.cat.realty.frontend,
    title: 'Довідник нерухомості',
    desc: 'Довідник нерухомості',
    icon: EStateFieldIcon,
  },
  {
    url: meta.cat.lands.frontend,
    title: 'Довідник земельних ділянок',
    desc: 'Довідник земельних ділянок',
    icon: Regions,
  },
  {
    url: meta.cat.easements.frontend,
    title: 'Сервітути',
    desc: 'Сервітути',
    icon: Regions,
  },
  {
    url: meta.cat.specialpurpose.frontend,
    title: 'Довідник призначень земельних ділянок',
    desc: 'Довідник призначень земельних ділянок',
    icon: Regions,
  },
  {
    url: '/addr/',
    title: 'Довідники адресного класифікатора',
    desc: 'Довідники адресного класифікатора',
    icon: Regions,
  },
  {
    url: meta.cat.stateproperties.frontend,
    title: 'Класифікатор державного майна',
    desc: 'Класифікатор державного майна',
    icon: ContractIcon,
  },
  {
    url: meta.cat.sessiondecision.frontend,
    title: 'Рішення сесії',
    desc: 'Рішення сесії',
    icon: ContractIcon,
  },
  {
    url: meta.cat.budgetaryinstitutions.frontend,
    title: 'Довідник Бюджетних установ',
    desc: 'Довідник Бюджетних установ"',
    icon: BranchIcon,
  },
];
function DictPage() {
  return <SubPage pageTitle="Довіднки" items={items} />;
}

export default DictPage;
